'use client';
import React, { Suspense } from 'react';
import Loading from './loading';

export default function Template({ children }) {
  return (
    <Suspense fallback={<Loading data-component-id="src/app/template.jsx:7:24" data-component-path="src/app/template.jsx" data-component-line="7" data-component-end-line="7" data-component-file="template.jsx" data-component-name="Loading" data-component-content="%7B%22elementName%22%3A%22Loading%22%7D" />}>
      <div data-component-id="src/app/template.jsx:8:6" data-component-path="src/app/template.jsx" data-component-line="8" data-component-end-line="10" data-component-file="template.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22page-transition%22%7D" className="page-transition">
        {children}
      </div>
    </Suspense>
  );
}
